import React from 'react'
import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'
import Blog from '../container/Blog/Blog'

const Blogs = () => {
  return (
    <>
    <Navbar/>
    <Blog/>
    <Footer/>
    </>
  )
}

export default Blogs